<template>
  <div class="registration-form__username-password-container">
    <h3 class="registration-form__subtitle">Create your username and password:</h3>
    <fieldset v-show="formFields.registrationUserName 
                && !formFields.registrationUserName.isHidden" 
              id="userNameField"
              class="wk-js2 registration-form-field">
      <UtdTextInput label="Username"
                    :is-error="checkFieldInvalid(REG_FIELD.USER_NAME) 
                      && isDirty.registrationUserName"
                    :error-message="$t(userNameErrorMessage())"
                    :required="formFields.registrationUserName?.required">
        <input id="registrationUserName"
               v-model="form.registrationUserName"
               aria-label="Username"
               :maxlength="formFields.registrationUserName?.maxLength"
               type="text"
               class="wk-field-input form-field jumpstart-input"
               autocomplete="username"
               @input="checkResetServerError(REG_FIELD.USER_NAME)"
               @blur="() => isDirty.registrationUserName = true">
      </UtdTextInput>
    </fieldset>
    
    <fieldset id="passwordField"
              class="wk-js2 registration-form-field">
      <UtdPasswordInput :label="$t('LOGIN.PASSWORD')"
                        :is-error="checkFieldInvalid(REG_FIELD.PASSWORD) && isDirty.password"
                        :error-message="$t(passwordErrorMessage())"
                        :required="formFields.password?.required"
                        @text-input-toggle-show="togglePasswordVisibleInput">
        <input id="password"
               v-model="form.password"
               :type="newPasswordInputType"
               :maxlength="formFields.password?.maxLength"
               aria-label="Password"
               class="wk-field-input form-field jumpstart-input"
               autocomplete="new-password"
               @input="checkResetServerError(REG_FIELD.PASSWORD)"
               @blur="() => isDirty.password = true">
      </UtdPasswordInput>
    </fieldset>

    <fieldset class="registration-form__passwword-rules">
      <h4>Password rules:</h4>
      <PasswordRules class="ds1-ml-1" />
    </fieldset>

    
    <fieldset id="verifyPasswordField"
              class="wk-js2 registration-form-field">
      <UtdPasswordInput label="Verify Password"
                        :is-error="checkFieldInvalid(REG_FIELD.VERIFY_PASSWORD) 
                          && isDirty.verifyPassword"
                        :error-message="$t(getFieldErrorMessage(REG_FIELD.VERIFY_PASSWORD))"
                        :required="formFields.verifyPassword?.required"
                        @text-input-toggle-show="toggleVerifyPasswordVisibleInput">
        <input id="verifyPassword"
               v-model="form.verifyPassword"
               :type="verifyPasswordInputType"
               :maxlength="formFields.verifyPassword?.maxLength"
               aria-label="Verify Password"
               class="wk-field-input form-field jumpstart-input"
               autocomplete="new-password"
               @input="checkResetServerError(REG_FIELD.VERIFY_PASSWORD)"
               @blur="() => isDirty.verifyPassword = true">
      </UtdPasswordInput>
    </fieldset>
  </div>
</template>

<script setup>
import UtdTextInput from '_acaSrc/components/shared/input/UtdTextInput.vue';
import UtdPasswordInput from '_acaSrc/components/shared/input/UtdPasswordInput.vue';
import PasswordRules from '_acaSrc/components/login/PasswordRules.vue';
import useRegistrationForm from '_acaSrc/composables/registrationForm.composable';
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import { REG_FIELD } from '_acaSrc/utility/constants';

const store = useStore();

const registrationForm = computed(() => store.getters['login/registrationForm']);
const formFields = computed(() => registrationForm.value.formFields);

const newPasswordInputType = ref('password');
const verifyPasswordInputType = ref('password');

const togglePasswordVisibleInput = (hideText) => {
    newPasswordInputType.value = hideText ? 'password' : 'text';
};

const toggleVerifyPasswordVisibleInput = (hideText) => {
    verifyPasswordInputType.value = hideText ? 'password' : 'text';
};

const {
    form,
    isDirty,
    checkResetServerError,
    checkFieldInvalid,
    getFieldErrorMessage,
    userNameErrorMessage,
    passwordErrorMessage
} = useRegistrationForm();
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

@media only screen and (min-width: 768px) {
  .registration-form__username-password-container {
    .ds1-mh-2();
  }
}

.registration-form__passwword-rules {
  .ds1-mb-2();
  border: none;
}

.registration-form__username-password-container {
  .ds1-mt-3();
}

</style>